var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconos32PxFase2B1Generic15({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;}.cls-3{fill:#39b54a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICONOS-32PX-FASE-2b.1-GENERIC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.53,20.73h0l-8.89-.08v-.72l8.89.08h0a1.68,1.68,0,0,0,1.13-.42,1.33,1.33,0,0,0,.46-1,1.51,1.51,0,0,0-1.58-1.43l-8.78-.08a.36.36,0,0,1-.34-.25L8.63,8.2l-2.16,0V7.46l2.42,0a.36.36,0,0,1,.34.25L12,16.41l8.52.07a2.22,2.22,0,0,1,2.28,2.15,2,2,0,0,1-.7,1.51A2.39,2.39,0,0,1,20.53,20.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.64,24.35h0a1.65,1.65,0,0,1,0-3.31,1.63,1.63,0,0,1,1.17.5,1.66,1.66,0,0,1-1.17,2.81Zm0-2.59a.94.94,0,0,0,0,1.88v0A.94.94,0,0,0,15.3,22,.91.91,0,0,0,14.65,21.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.14,24.39h0a1.65,1.65,0,1,1,1.66-1.64A1.65,1.65,0,0,1,20.12,24.39Zm0-2.59a.94.94,0,0,0,0,1.88v0a.94.94,0,0,0,0-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.88,17l-.68-.23,2.15-6.39-2.22-.11V9.51l2.71.12a.36.36,0,0,1,.34.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.64 10.34 11.86 10.22 11.85 9.51 9.14 9.62 9.64 10.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.65,9.19V7a.27.27,0,0,0-.27-.27H13.87a.27.27,0,0,0-.27.27V9.19a1.54,1.54,0,0,0-1.05,1.27v3.76a.88.88,0,0,0,.6.83v1.28a.27.27,0,0,0,.27.27h5.42l.11,0,.08-.05a.27.27,0,0,0,.08-.19V15.05a.88.88,0,0,0,.6-.83V10.46A1.54,1.54,0,0,0,18.65,9.19Zm-1.44,6.12H15l-.21-.21h2.6Zm-2.79.16.3.3a.27.27,0,0,0,.19.08h2.41l.11,0,.08-.05.3-.3a.27.27,0,0,0,0-.37h.73v1H13.69v-1h.73a.27.27,0,0,0,0,.37ZM18.19,9.6a.27.27,0,0,0,.19.08,1,1,0,0,1,.46.23.78.78,0,0,1,.33.55v3.76a.33.33,0,0,1-.33.33H13.41a.33.33,0,0,1-.33-.33V10.46c0-.34.37-.62.61-.73a.49.49,0,0,1,.17-.05.27.27,0,0,0,.27-.27V7.27h4V9.41A.27.27,0,0,0,18.19,9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.63,7.48h-3a.27.27,0,0,0-.27.32l.3,1.5a.27.27,0,0,0,.27.22h2.41l.11,0a.27.27,0,0,0,.15-.19l.3-1.5a.27.27,0,0,0-.27-.32ZM17.3,8,17.1,9h-2l-.19-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.15,10.1a2.07,2.07,0,1,0,2.07,2.07A2.07,2.07,0,0,0,16.15,10.1Zm0,3.72a1.66,1.66,0,1,1,1.66-1.66A1.66,1.66,0,0,1,16.15,13.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.55 11.58 16.13 12.25 15.88 12.66 15.35 12.12 15.01 12.45 15.96 13.43 16.13 13.16 16.54 12.5 17.29 11.28 16.89 11.03 16.55 11.58"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconos32PxFase2B1Generic15);
export default __webpack_public_path__ + "static/media/ICONOS-32PX-FASE-2b.1-GENERIC-15.b6669709a3d2de259ddaf65c440b83b6.svg";
export { ForwardRef as ReactComponent };